import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointLeft } from '@fortawesome/pro-light-svg-icons';
import { useTranslations } from '../../../../../../../../../../../../../../../../../../../../../../hooks/useTranslations';
import { FormattedMessage } from 'react-intl';
import { Button, Tooltip } from 'reactstrap';
import useOpen from '../../../../../../../../../../../../../../../../../../../../../../hooks/useOpen';
import { useHandleApply } from './hooks/useHandleApply';

type UseExistingQuestionActionProps = {
  id: string;
  onResolve: () => void;
};

const UseExistingQuestionAction = ({
  id,
  onResolve,
}: UseExistingQuestionActionProps) => {
  const { isOpen, toggle } = useOpen();

  const { attachPrefix } = useTranslations(
    'ConversationsAndFeedbacks.ConversationTemplates.ImportTemplateModal.Content.ConflictsStep.Validation.Response.Conflicts.QuestionActions.UseExistingQuestionAction'
  );

  const handleApply = useHandleApply(id, onResolve);

  return (
    <>
      <Button
        id={`question-use-existing-${id}`}
        color="primary"
        outline={true}
        onClick={handleApply}
      >
        <FontAwesomeIcon icon={faHandPointLeft} />
      </Button>
      <Tooltip
        placement="top"
        isOpen={isOpen}
        target={`question-use-existing-${id}`}
        toggle={toggle}
      >
        <FormattedMessage id={attachPrefix('useExisting')} />
      </Tooltip>
    </>
  );
};

export default UseExistingQuestionAction;
